import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authGuard } from '../../shared/auth/auth.guard';

export const admin: Routes = [
  {
    path: "bollette/rete-commerciale",
    loadComponent: () =>
      import("./associazioni.component").then((m) => m.AssociazioniComponent),
    canActivate: [authGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class AssociazioniRoutingModule {
  static routes = admin;
}
